import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPost } from "@client/lib/api";
import type { SessionUser } from "@shared/types/index";
import type { LoginInput } from "@shared/schemas/index";

export function useUser() {
  return useQuery<SessionUser>({
    queryKey: ["auth", "me"],
    queryFn: () => apiGet<SessionUser>("/api/auth/me"),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    // Login answers 204 and sets the cookie; the user is then fetched rather than returned.
    mutationFn: (data: LoginInput) => apiPost<void>("/api/auth/login", data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["auth", "me"] }),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiPost<void>("/api/auth/logout"),
    onSuccess: () => {
      qc.clear();
      location.href = "/login";
    },
  });
}
